<template>
  <div class="login-content" v-if="userType">

    <login-form :userType="userType">
      <div slot="createAccount">
        <span class="log__account mt-2" @click="openAccount" v-if="!createAccount">
          {{ $t("auth.account") }}
        </span>
      </div>
    </login-form>

    <div class="login-content__signup" v-if="createAccount">
      <button class="login-content__close-singup" @click="createAccount = false">X</button>
      <signup-form :userType="userType"></signup-form>
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/Auth/Login/Form';
import SignupForm from '@/components/Auth/Signup/Form';

export default {
  components: { LoginForm, SignupForm },
  props: ['userType'],
  data() {
    return {
      createAccount: false,
    };
  },
  methods: {
    openAccount() {
      this.createAccount = true;
      setTimeout(() => {
        this.$scrollTo('#createAccount', 1000, { container: '#js-logModal' });
      }, 100);
    },
  },
};
</script>

<style lang="scss">
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.login-content {
  margin-bottom: 100px;
  @include media('<md') {
    margin-bottom: 50px;
  }

  &__login{
    padding: 50px;
    background-color: $color--gray-5;
    @include media('<md') {
      padding: 50px 30px;
    }
  }
  &__signup{
    padding: 50px;
    padding-top: 0;
    position: relative;
    background-color: transparent;
     @include media('<md') {
      padding: 10px 30px 30px;
    }
  }
  &__close-singup{
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
.log {
  &__text {
    color: $color--gray-3;
    font-size: 20px;
    display: block;
    margin-bottom: 25px;
    @include media('<md') {
      font-size: 14px;
    }
  }
  &__title {
    color: $color--gray-3;
    padding-top: 75px;
    @include media('<md') {
      padding-top: 50px;
    }
  }
  &__password {
    color: $color--gray-3;
    font-size: 14px;
    margin-top: 5px;
    cursor: pointer;
    &:disabled{
      cursor: wait;
    }
    @include media('<xl') {
      font-size: 12px;
    }
  }
  &__account {
    color: $color--gray-3;
    border-bottom: 1px solid $color--orange;
    font-size: 14px;
    cursor: pointer;
    @include media('<xl') {
      font-size: 12px;
    }
  }
  &__label {
    display: block;
    font-size: 16px;
    color: $color--black;
    @include media('<md') {
      font-size: 14px;
    }
  }
  &__succes{
    display: block;
    text-align: center;
    margin-top: 10px;
    color: $color--green;
    font-size: 16px;
  }
  &__img {
    width: 300px;
    height: auto;
    @include media('<xl') {
      width: 100%;
    }
  }
  &__input {
    position: relative;
  }
  &__password-visible {
    cursor: pointer;
    color: $color--black;
    position: absolute;
    top: 10px;
    right: 15px;
  }
}
.button {
  &--margin {
    margin-top: 0px;
  }
}

::-webkit-input-placeholder {
  color: $color--gray;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/Index.vue